import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError, concat, of, pipe } from 'rxjs';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class DataService {
    private navId = new BehaviorSubject('')
    navigationId = this.navId.asObservable()
    private depotId = new BehaviorSubject('')
    navigationdepotId = this.depotId.asObservable()
    private depotName = new BehaviorSubject('')
    navigationdepotName = this.depotName.asObservable()
    private handoverId = new BehaviorSubject('')
    handOverSlipID = this.handoverId.asObservable()
    constructor(private http: HttpClient ) { }

    getService<T>(url: string): Observable<any> {
        return this.http
            .get(url)
            .pipe(
                map((data: T) => {
                    return data;
                }), catchError(error => {
                    return throwError('Something went wrong!');
                })
            );
    }
    getViewService(id) {
       this.navId.next(id)
    }
    getViewDepotId(id) {
        this.depotId.next(id)
    }
    getViewDepotName(name) {
        this.depotName.next(name)
    }
    getTestSlipId(id) {
        this.handoverId.next(id)
    }

    getServiceWithDynamicQueryTerm(url: string, key: string, val: string): Observable<any> {
        return this.http
            .get(url + '/?' + key + '=' + val)
            .pipe(map(this.extractData))
            .pipe(catchError(this.handleError));
    }

    getServiceWithMultipleQueryTerm(url: string, query: string): Observable<any> {
        return this.http
            .get(url + '?' + query)
            .pipe(map(this.extractData))
            .pipe(catchError(this.handleError));
    }

    getServiceWithComplexObjectAsQueryString(url: string, param: any): Observable<any> {
        const params: any = new URLSearchParams();
        for (const key in param) {
            if (param.hasOwnProperty(key)) {
                const val = param[key];
                params.set(key, val);
            }
        }
        return this.http
            .get(url, params)
            .pipe(map(this.extractData))
            .pipe(catchError(this.handleError));
    }

    createServiceFullResponse(url: string, param: any): Observable<any> {
        return this.http
            .post(url, param, {
                observe: 'response'
            })
            .pipe(map(this.extractData))
            .pipe(catchError(this.handleError));
    }


    getViewSlipFullResponse(url: string): Observable<any> {
        return this.http
            .get(url)
            .pipe(map(this.extractData))
            .pipe(catchError(this.handleError));
    }

    createServiceTextResponseType(url: string): Observable<any> {
        return this.http
            .get(url,{responseType: 'text'})
            .pipe(map(this.extractData))
            .pipe(catchError(this.handleError));
    }

    createService(url: string, param: any): Observable<any> {
      return this.http
          .post(url, param)
          .pipe(map(this.extractData))
          .pipe(catchError(this.handleError));
  }


    updateService(url: string, param: any): Observable<any> {
        return this.http
            .put(url, param)
            .pipe(map(this.extractData))
            .pipe(catchError(this.handleError));
    }

    patchService(url: string, param: any): Observable<any> {
        return this.http
            .patch(url, param)
            .pipe(map(this.extractData))
            .pipe(catchError(this.handleError));
    }

    deleteService(url: string, param: any): Observable<any> {
        const params: any = new URLSearchParams();
        for (const key in param) {
            if (param.hasOwnProperty(key)) {
                const val = param[key];
                params.set(key, val);
            }
        }
        return this.http
            .delete(url, params)
            .pipe(map(this.extractData))
            .pipe(catchError(this.handleError));
    }

    deleteServiceWithId(url: string, key: string, val: string): Observable<any> {
        return this.http
            .delete(url + '/?' + key + '=' + val)
            .pipe(map(this.extractData))
            .pipe(catchError(this.handleError));
    }

    private extractData(res: any) {
        const body = res;
        return body || {};
    }

    private handleError(error: any) {
      const errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        return throwError(errMsg);
    }
    deleteComments(url: string): Observable<any> {
        return this.http
            .delete(url)
            .pipe(map(this.extractData))
            .pipe(catchError(this.handleError));
    }
    gethandoverSlipData(url: string): Observable<any> {
        return this.http
            .get(url)
            .pipe(map(this.extractData))
            .pipe(catchError(this.handleError));
    }
    decrypt(key, ciphertextB64) {
        var key = CryptoJS.enc.Utf8.parse(key);
        var iv = CryptoJS.lib.WordArray.create([0x00, 0x00, 0x00, 0x00]);
        var decrypted = CryptoJS.AES.decrypt(ciphertextB64, key, { iv: iv });
        return decrypted.toString(CryptoJS.enc.Utf8);
    }
    static encryptData(msg) {
        var keySize = 256;
        var salt = CryptoJS.lib.WordArray.random(16);
        var key = CryptoJS.PBKDF2(environment.ENCRYPTKEY_DATA, salt, {
            keySize: keySize / 32,
            iterations: 100
        });

        var iv = CryptoJS.lib.WordArray.random(128 / 8);

        var encrypted = CryptoJS.AES.encrypt(msg, key, {
            iv: iv,
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC
        });

        var result = CryptoJS.enc.Base64.stringify(salt.concat(iv).concat(encrypted.ciphertext));

        return result;
    }
}
